import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://luxejobslondon.co.uk';
const PRIVATE_PATHS = ['/auth', '/admin', '/verify-live-data'];

const SeoDefaults = () => {
  const { pathname } = useLocation();
  const canonicalPath = pathname === '/' ? '' : pathname.replace(/\/$/, '');
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;
  const isPrivate = PRIVATE_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Luxe Jobs London',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/jobs?keyword={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content="Luxe Jobs London" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="robots" content={isPrivate ? 'noindex, nofollow' : 'index, follow'} />
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  );
};

export default SeoDefaults;
